import React, { ReactNode, ReactElement, useCallback, useMemo } from 'react';
import { FieldValues, Control, Controller } from 'react-hook-form';
import cx from 'clsx';

import { Checkbox, CheckboxProps } from '../Checkbox';

import style from './index.module.scss';
import { HelperTooltip } from '@/components';

export const CheckableFields = ({
  control,
  fields,
  className,
  anyOf,
  disabled,
  cols = 2,
  type = 'form',
}: {
  control: Control<FieldValues, object>;
  className?: string;
  // [行[列]]
  fields: Array<{
    label: ReactNode;
    name: string;
    labelClassName?: string;
    labelContainerClassName?: string;
    desc?(v?: string | number): ReactNode;
    render?: (control: Control<FieldValues, object>, disabled?: boolean) => ReactElement;
    disabled?: boolean;
    disabledTip?: ReactNode;
  }>;
  anyOf?: boolean;
  disabled?: boolean;
  cols?: number;
  type?: CheckboxProps['type'];
}) => {
  // submit 中取值
  // 有 render：[checked, value]
  // 或无 render: value

  const validate = useCallback(
    (v, d) => {
      if (anyOf) {
        return fields.flat().some(x => !!x.name.split('.').reduce((m, n) => m[n], d));
      }
    },
    [anyOf, fields],
  );

  const rules = useMemo(() => ({ validate }), [validate]);

  return (
    <div
      className={cx(style.formBody, className)}
      style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
      {fields.map(m => (
        <div className={cx(style.formField, m.labelContainerClassName)} key={m.name}>
          <div className={cx(style.fieldLabel, m.labelClassName)}>
            <Controller
              // 无 render 代表本字段就是一个 checkbox，无需分成 [checkbox, value] 的形式
              name={m.render ? `${m.name}.0` : `${m.name}`}
              control={control}
              rules={rules}
              render={({ field, fieldState }) => (
                <HelperTooltip title={m?.disabled ? m?.disabledTip : undefined}>
                  <Checkbox
                    type={type}
                    onChange={field.onChange}
                    checked={field.value}
                    disabled={disabled || m?.disabled}>
                    <span className={style.fieldLabelText}>{m.label}</span>
                  </Checkbox>
                </HelperTooltip>
              )}
            />
          </div>
          {m.render?.(control, disabled)}
        </div>
      ))}
    </div>
  );
};
